module.exports = new __parcel__URL__("github.55e24207.svg").toString();